const SIZE_LIMITS = {
  image: 5 * 1024 * 1024,
  video: 16 * 1024 * 1024,
  document: 100 * 1024 * 1024,
  audio: 16 * 1024 * 1024,
};

const MIME_TYPES = {
  image: new Set(["image/jpeg", "image/jpg", "image/png"]),
  video: new Set(["video/mp4", "video/3gpp"]),
  document: new Set([
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/plain",
  ]),
  audio: new Set([
    "audio/aac",
    "audio/mp4",
    "audio/amr",
    "audio/mpeg",
    "audio/ogg",
    "audio/ogg; codecs=opus",
  ]),
};

const EXT_MAP = {
  image: [".jpg", ".jpeg", ".png"],
  video: [".mp4", ".3gp", ".3gpp"],
  document: [".pdf", ".doc", ".docx", ".ppt", ".pptx", ".xls", ".xlsx", ".txt"],
  audio: [".aac", ".mp4", ".amr", ".mp3", ".mpeg", ".ogg"],
};

const detectKind = (file) => {
  const mime = String(file?.type || "").toLowerCase();
  if (mime.startsWith("image/")) return "image";
  if (mime.startsWith("video/")) return "video";
  if (mime.startsWith("audio/")) return "audio";
  return "document";
};

const hasAllowedExtension = (filename, kind) => {
  const name = String(filename || "").toLowerCase();
  return EXT_MAP[kind].some((ext) => name.endsWith(ext));
};

export const validateTaskTemplateFile = (file) => {
  if (!file) return { valid: false, error: "No file selected." };
  const kind = detectKind(file);
  const mime = String(file.type || "").toLowerCase();
  const size = Number(file.size || 0);

  const mimeAllowed = MIME_TYPES[kind].has(mime);
  const extAllowed = hasAllowedExtension(file.name, kind);
  if (!mimeAllowed && !extAllowed) {
    return {
      valid: false,
      error: "File format is not supported for upload.",
    };
  }

  const max = SIZE_LIMITS[kind];
  if (size > max) {
    const maxMb = (max / (1024 * 1024)).toFixed(0);
    return {
      valid: false,
      error: `File size exceeds the limit (${maxMb} MB).`,
    };
  }

  return { valid: true };
};
